import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { serviceList } from '../../data/services/servicesRegistry';
import {
  homeScrollItem,
  homeScrollStagger,
  homeScrollViewport,
} from '../../utils/homeScrollMotion';
import styles from './RelatedServices.module.css';

const RelatedServices = ({ currentSlug }) => {
  const others = serviceList.filter((service) => service.slug !== currentSlug);

  if (others.length === 0) return null;

  return (
    <section className={styles.section} aria-labelledby="related-heading">
      <motion.h2
        id="related-heading"
        className={styles.title}
        variants={homeScrollItem}
        initial="hidden"
        whileInView="visible"
        viewport={homeScrollViewport}
      >
        Other services
      </motion.h2>

      <motion.ul
        className={styles.grid}
        variants={homeScrollStagger}
        initial="hidden"
        whileInView="visible"
        viewport={homeScrollViewport}
      >
        {others.map((service) => {
          const Icon = service.icon;

          return (
            <motion.li key={service.slug} variants={homeScrollItem}>
              <Link to={`/services/${service.slug}`} className={styles.card}>
                <div className={styles.cardTop}>
                  <div className={styles.cardIdentity}>
                    <span className={styles.iconWrap} aria-hidden="true">
                      <Icon size={16} strokeWidth={2.2} />
                    </span>
                    <h3 className={styles.name}>{service.title}</h3>
                  </div>
                  <span className={styles.tag}>{service.kicker}</span>
                </div>
                <p className={styles.summary}>{service.summary}</p>
                <span className={styles.readMore}>
                  View service
                  <ArrowUpRight size={13} strokeWidth={2.5} aria-hidden="true" />
                </span>
              </Link>
            </motion.li>
          );
        })}
      </motion.ul>
    </section>
  );
};

export default RelatedServices;
